import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { BsSnapchat, BsTwitterX } from "react-icons/bs";
import { CiFacebook, CiLinkedin, CiYoutube } from "react-icons/ci";
import { MdOutlineMailOutline } from "react-icons/md";
import BottomNavNew from "../components/BottomNavNew";
import {
  IoLogoInstagram,
  IoMailOutline,
  IoPhonePortraitOutline,
} from "react-icons/io5";
import { PiTiktokLogo } from "react-icons/pi";
import { isRTLLanguage } from '../utils/languageUtils';

const FooterMain = () => {
  const { t, i18n } = useTranslation();
  const activeLanguage = i18n.language; // 'en', 'ar', or 'ur'
  const isRTL = isRTLLanguage(activeLanguage);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, []);
  return (
    <div className="w-full flex flex-col justify-center items-center ">
      <div className=" w-full flex py-6 bg-gradient-to-b from-[#ECF2FF] to-[#fff]">
        <div className={`mx-auto w-[80%] flex ${isRTL ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-2 items-center flex-col justify-between`}>
          <div className={`${isRTL ? 'flex flex-row gap-3' : 'flex flex-row-reverse gap-3'}`}>
            <button className="btn bg-[#003E6F] text-white hover:bg-[#b6953e]">
              {t('subscribe')}
            </button>
            <label className={`justify-end text-end lg:w-[300px] flex items-center gap-2 hover:border px-4 py-2 active:border rounded-lg outline outline-1`}>
              <MdOutlineMailOutline size={22} className={`${isRTL ? 'hidden' : ''}`} />
              <input
                type="text"
                className={`grow outline-none bg-transparent border-none justify-end pr-2 ${isRTL ? 'text-end' : ''}`}
                placeholder={t('email')}
              />
              <MdOutlineMailOutline size={22} className={`${isRTL ? '' : 'hidden'}`} />
            </label>
          </div>
          <div>
            <h1 className={`font-bold ${isRTL ? 'text-end text-[20px]' : 'text-[17px]'}`}>
              {t("footerEmailText")}
            </h1>
          </div>
        </div>
      </div>
      <div className=" w-full flex">
        <div className=" w-[80%] flex flex-col mx-auto">
          <div className=" w-full grid lg:grid-cols-5 grid-cols-2 gap-5 py-20">
            {/* Company Info Section */}
            <div className={`flex flex-col lg:col-span-2 gap-5 ${isRTL ? 'items-end' : 'items-start'}`}>
              <img
                src="/Images/lllll.png"
                className="w-20 h-20"
                alt=""
              />
              <h1 className={`text-xl text-[#525A6A] lg:w-[280px] ${isRTL ? 'text-end' : 'text-start'}`}>
                {t('footerMainText')}
              </h1>
            </div>

            {/* About Section */}
            <div className={`flex flex-col gap-2 ${isRTL ? 'items-end' : 'items-start'}`}>
              <h1 className={`text-2xl pb-3 font-bold text-[#000929] ${isRTL ? 'text-end' : 'text-start'}`}>
                {t('about us')}
              </h1>
              <a href="/" className={`text-[#000929] text-base font-medium opacity-55 ${isRTL ? 'text-end' : 'text-start'}`}>
                {t('home')}
              </a>
              <a href="/whatwedo" className={`text-[#000929] text-base font-medium opacity-55 ${isRTL ? 'text-end' : 'text-start'}`}>
                {t('about us')}
              </a>
              <a href="/services" className={`text-[#000929] text-base font-medium opacity-55 ${isRTL ? 'text-end' : 'text-start'}`}>
                {t('services')}
              </a>
              <a href="/blog" className={`text-[#000929] text-base font-medium opacity-55 ${isRTL ? 'text-end' : 'text-start'}`}>
                {t('blogs')}
              </a>
            </div>

            {/* Contact Section */}
            <div className={`flex flex-col gap-2 ${isRTL ? 'items-end' : 'items-start'}`}>
              <h1 className={`text-2xl pb-3 font-bold text-[#000929] ${isRTL ? 'text-end' : 'text-start'}`}>
                {t('contact us')}
              </h1>
              <a href="/contacts" className={`text-[#000929] text-base font-medium opacity-55 ${isRTL ? 'text-end' : 'text-start'}`}>
                {t('contact us')}
              </a>
              <a href="/faq" className={`text-[#000929] text-base font-medium opacity-55 ${isRTL ? 'text-end' : 'text-start'}`}>
                {t('faq')}
              </a>
              <a
                href="/contacts/tandc"
                className={`text-[#000929] text-base font-medium opacity-55 ${isRTL ? 'text-end' : 'text-start'}`}
              >
                {t('termsAndConditions')}
              </a>
              <a
                href="/contacts/privacyPolicy"
                className={`text-[#000929] text-base font-medium opacity-55 ${isRTL ? 'text-end' : 'text-start'}`}
              >
                {t('privacyPolicy')}
              </a>
            </div>

            {/* Address Section */}
            <div className={`flex flex-col gap-4 ${isRTL ? 'items-end' : 'items-start'}`}>
              <h1 className={`text-2xl font-bold ${isRTL ? 'text-end' : 'text-start'}`}>
                {t('title')}
              </h1>
              <div className={`flex ${isRTL ? 'flex-row' : 'flex-row-reverse'} gap-2`}>
                <div>
                  <p className={`text-base font-bold ${isRTL ? 'text-end' : 'text-start'}`}>
                    {t('riyadh')}
                  </p>
                  <p className={`text-base opacity-55 ${isRTL ? 'text-end' : 'text-start'}`}>
                    {t('riyadhLocation')}
                  </p>
                </div>
                <img
                  src="\Images\marker-pin-05ddddd.png"
                  className="w-4 h-4"
                  alt=""
                />
              </div>
              <div className={`flex ${isRTL ? 'flex-row' : 'flex-row-reverse'} gap-2`}>
                <div>
                  <p className={`text-base font-bold ${isRTL ? 'text-end' : 'text-start'}`}>
                    {t('Jeddah')}
                  </p>
                  <p className={`text-base opacity-55 ${isRTL ? 'text-end' : 'text-start'}`}>
                    {t('jeddahLocation')}
                  </p>
                </div>
                <img
                  src="\Images\marker-pin-05ddddd.png"
                  className="w-4 h-4"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <BottomNavNew />
      <div className=" w-[100%] flex lg:h-12 bg-[##F3F4F5] py-2 justify-center items-center ">
        <div className="w-[90%] flex lg:flex-row flex-col justify-between items-center">
          <div className=" flex lg:flex-row flex-col items-center gap-2 ">
            <div className="flex items-center gap-4">
              <a href="https://twitter.com/fawazlawyer" target="_blank">
                <BsTwitterX size={20} className="  text-[#000929]" />
              </a>
              <a href="#">
                <CiFacebook size={25} className="  text-[#000929]" />
              </a>
              <a href="https://www.instagram.com/fawazlawyer_/">
                <IoLogoInstagram size={25} className="  text-[#000929]" />
              </a>
              <a href="#" className=" flex">
                <CiLinkedin size={25} className="  text-[#000929]" />
              </a>
              <a href="https://youtube.com/@user-wf5vr3ky7b?si=0m7Iwc7oJkb_EroL" target="_blank" className=" flex">
                <CiYoutube size={25} className="  text-[#000929]" />
              </a>
            </div>
            <div className=" flex items-center gap-2 ">
              <a href="#" className=" flex items-center gap-1 pl-2">
                <IoPhonePortraitOutline
                  size={20}
                  className="  text-[#000929]"
                />
                <p className=" text-[#000929] text-[14px]">+966920013767</p>
              </a>
              <a href="#" className=" flex items-center gap-1 pl-2">
                <IoMailOutline size={20} className="  text-[#000929]" />
                <p className=" text-[#000929] text-[14px]">info@fawazlaw.sa</p>
              </a>
            </div>
          </div>
          <div className=" items-center lg:text-base text-sm gap-2 text-end lg:flex text-[#3E4450]">
            {t("footerTerms")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterMain;
